module.exports = __webpack_public_path__ + "static/solution11-1e1f616ee9232f1bf595c1903ed4d933.png";